import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setSort, setToastsError, setToastsSuccess } from '../../../redux/actions/common';
import Tabs from '../../common/Tabs';
import Button from '../../common/Button';
import Modal from '../../common/Modal';
import Pagination from '../../common/Pagination';
import Card from '../../common/Card';
import Choice from '../../common/Choice';
import { RECEIVER_TYPE } from '../../../utils/constants/string';
import SelectSearch from '../../common/SelectSearch';
import Input from '../../common/Input';
import { RULE } from '../../../utils/constants/regex';
import EditTable from '../../tables/EditTable';
import { fetchDepartments, setLoader } from '../../../redux/actions/api';
import { EmailReceiverControllerService } from '../../../services';
import {
    getTableNearbyStoreTab,
    getTableRequestDissociatedTab,
    getTableBelowCostTab,
    getTableRequestApplyCompetitorStoreTab,
} from '../../tables/table';
import { createDepartmentOptions } from '../../../utils/helpers/option';
import apiErrorHandler from '../../../api/apiErrorHandler';
import { useLocation } from 'react-router-dom';
import { clearErrors } from '../../../redux/actions/error';
import { RequiredBadge } from '../../common/RequiredBadge';
import DeleteModal from '../../modals/DeleteModal';

const Notification = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const sort = useSelector((state) => state.sort);

    const constants = useSelector((state) => state.constants);
    const { departments } = constants;

    const [state, setState] = useState({
        isShowModalRegister: false,
        selectedReceiverType: 'DISSOCIATED',
        departmentCode: '',
        email: '',
        isCheckEmail: false,
        isShowDeleteModal: false,

        page: 1,
        limit: 20,
        apiResponse: null,
        receiverType: 'DISSOCIATED',
    });

    const {
        isShowModalRegister,
        selectedReceiverType,
        departmentCode,
        email,
        isCheckEmail,
        isShowDeleteModal,
        page,
        limit,
        apiResponse,
        receiverType,
    } = state;

    const [formData, setFormData] = useState(null);

    const handleDeleteClick = (index, value) => {
        setFormData(value);
        handleChangeState('isShowDeleteModal', true);
    };

    const tableRequestDissociatedTab = getTableRequestDissociatedTab(t, handleDeleteClick);
    const tableNearbyStoreTab = getTableNearbyStoreTab(t, handleDeleteClick);
    const tableBelowCostTab = getTableBelowCostTab(t, handleDeleteClick);
    const tableRequestApplyCompetitorStoreTab = getTableRequestApplyCompetitorStoreTab(t, handleDeleteClick);

    useEffect(() => {
        dispatch(clearErrors());
        dispatch(setSort());
        dispatch(fetchDepartments());
    }, [dispatch, location]);

    useEffect(() => {
        getEmailReceivers(page);
    }, [dispatch, sort]);

    useEffect(() => {
        // 初回の処理ではしない
        if (isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        getEmailReceivers(1);
    }, [receiverType]);

    const getEmailReceivers = (pageNumber) => {
        dispatch(setLoader(true));
        dispatch(clearErrors());
        handleChangeState('page', pageNumber);
        EmailReceiverControllerService.getEmailReceivers(
            receiverType,
            pageNumber,
            limit,
            tableRequestDissociatedTab.heads.find((head) => head.field === sort.sortField)?.field,
            sort.sortType,
        )
            .then((response) => {
                setState((prevState) => ({
                    ...prevState,
                    apiResponse: response,
                }));
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error);
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

    const renderTable = (type) => {
        switch (type) {
            case 'DISSOCIATED':
                return (
                    <EditTable
                        isHeightTr
                        onlyTab
                        heads={tableRequestDissociatedTab.heads}
                        body={tableRequestDissociatedTab.body}
                        dataTable={apiResponse?.data}
                    />
                );
            case 'NEARBY_STORE':
                return (
                    <EditTable
                        isHeightTr
                        onlyTab
                        heads={tableNearbyStoreTab.heads}
                        body={tableNearbyStoreTab.body}
                        dataTable={apiResponse?.data}
                    />
                );
            case 'BELOW_COST':
                return (
                    <EditTable
                        isHeightTr
                        onlyTab
                        heads={tableBelowCostTab.heads}
                        body={tableBelowCostTab.body}
                        dataTable={apiResponse?.data}
                    />
                );
            case 'REQUEST_APPLY_COMPETITOR_STORE':
                return (
                    <EditTable
                        isHeightTr
                        onlyTab
                        heads={tableRequestApplyCompetitorStoreTab.heads}
                        body={tableRequestApplyCompetitorStoreTab.body}
                        dataTable={apiResponse?.data}
                    />
                );
            default:
                return null;
        }
    };

    const handlePageClick = (event) => {
        const pageNumber = event.selected + 1;
        getEmailReceivers(pageNumber);
    };

    const deleteItem = () => {
        dispatch(setLoader(true));
        dispatch(clearErrors());
        EmailReceiverControllerService.deleteEmailReceiver(formData.id)
            .then(() => {
                getEmailReceivers(1);
                dispatch(setToastsSuccess('削除が完了しました。'));
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error, t('message.error.delete'));
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
        setFormData(null);
    };

    const isShowTabMenu = [
        {
            title: '30％乖離通知',
            event: 'DISSOCIATED',
            content: renderTable('DISSOCIATED'),
        },
        {
            title: t('notification_registration.nav.nearby_store_email.title'),
            event: 'NEARBY_STORE',
            content: renderTable('NEARBY_STORE'),
        },
        {
            title: t('notification_registration.nav.below_cost_email.title'),
            event: 'BELOW_COST',
            content: renderTable('BELOW_COST'),
        },
        {
            title: t('notification_registration.nav.request_apply_competitor_store_email.title'),
            event: 'REQUEST_APPLY_COMPETITOR_STORE',
            content: renderTable('REQUEST_APPLY_COMPETITOR_STORE'),
        },
    ];

    const handleChangeState = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleShowSubmitModal = () => {
        setState((prevState) => ({
            ...prevState,
            isShowModalRegister: true,
        }));
    };

    const handleCloseModal = () => {
        handleClearForm();
    };

    const handleClearForm = () => {
        setState((prevState) => ({
            ...prevState,
            isShowModalRegister: false,
            selectedReceiverType: 'DISSOCIATED',
            departmentCode: '',
            email: '',
            isCheckEmail: false,
        }));
    };

    const handleSubmitFormNotification = async () => {
        if (validateEmail()) return;

        dispatch(setLoader(true));
        dispatch(clearErrors());
        EmailReceiverControllerService.createEmailReceiver({
            receiverType: selectedReceiverType,
            departmentCode: departmentCode,
            email: email,
        })
            .then(() => {
                getEmailReceivers(1);
                dispatch(setToastsSuccess('登録が完了しました。'));
                handleClearForm();
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error, t('message.error.registration'));
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

    const validateEmail = () => {
        if (
            (selectedReceiverType === 'DISSOCIATED' || selectedReceiverType === 'BELOW_COST') &&
            (departmentCode === null || departmentCode === '')
        ) {
            dispatch(clearErrors());
            dispatch(setToastsError('部門を選択してください。'));
            return true;
        }
        if (!RULE.EMAIL.test(email)) {
            setState((prevState) => ({
                ...prevState,
                isCheckEmail: true,
            }));
            return true;
        }
        return false;
    };

    const handleShowForm = (value) => {
        handleChangeState('receiverType', value);
    };

    const handleDeleteSubmit = () => {
        handleChangeState('isShowDeleteModal', false);
        deleteItem();
    };

    return (
        <>
            <div className="d-flex justify-content-end c-slide-top margin-bottom__18">
                <Button
                    id="submit-button"
                    className="btn btn--primary mr-2"
                    onClick={handleShowSubmitModal}
                    children={<span className="btn-text">{t('user.user-registration.button.register')}</span>}
                />
            </div>
            <div id="pagination" className="d-flex c-slide-top paginate-custom wp-pagination">
                <nav className="okc-pagination--notification okc-pagination--total ml-auto">
                    <p className="okc-pagination__total"></p>
                    <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                </nav>
            </div>
            <div className="ok_tab_table">
                <Tabs type="material" tabs={isShowTabMenu} handleClick={(event) => handleShowForm(event)} />
            </div>
            <div className="d-flex okc-pagination-bottom">
                <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
            </div>
            <Modal
                size="xl"
                title="通知先登録"
                isShowIconClose="true"
                isShow={isShowModalRegister}
                onClose={handleCloseModal}
                className="registration-edit-modal"
                btnList={[
                    {
                        name: t('notification_registration.registration_modal.ok_button'),
                        className: 'btn--primary',
                        onClick: () => handleSubmitFormNotification(),
                    },
                ]}
            >
                <div className="okc-card okc-result-form">
                    <Card type="modal_card">
                        <div className="row okc-card__row">
                            <div className="col-lg-3 okc-result-form__title notification-form__title">
                                <p>{t('notification_registration.registration_modal.notification')}</p>
                            </div>
                            <div className="col-lg-9 d-flex">
                                <div className="row no-gutters w-100">
                                    <Choice
                                        id="receiver-type-1"
                                        column="col-xl-3 col-lg-5 col-md-12"
                                        type="radio"
                                        data={RECEIVER_TYPE}
                                        onChange={(value) => handleChangeState('selectedReceiverType', value[0])}
                                        checked={[selectedReceiverType]}
                                    />
                                </div>
                            </div>
                        </div>
                        {(selectedReceiverType === 'DISSOCIATED' || selectedReceiverType === 'BELOW_COST') && (
                            <div className="row okc-card__row">
                                <div className="col-lg-3 okc-result-form__title notification-form__title">
                                    <p>
                                        {t('notification_registration.registration_modal.department')}
                                        <RequiredBadge />
                                    </p>
                                </div>
                                <div className="col-lg-9 d-flex">
                                    <SelectSearch
                                        onChange={(option) => {
                                            handleChangeState('departmentCode', option.value);
                                        }}
                                        options={createDepartmentOptions(departments)}
                                        value={departmentCode}
                                        placeholder={t('notification_registration.registration_modal.department')}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="row okc-card__row">
                            <div className="col-lg-3 okc-result-form__title notification-form__title">
                                <p>
                                    {t('notification_registration.registration_modal.mail_address')}
                                    <RequiredBadge />
                                </p>
                            </div>
                            <div className="col-lg-9 d-flex">
                                <div className="row no-gutters w-100">
                                    <div className="col-12 mb-2">
                                        <Input
                                            className={`${isCheckEmail ? 'form-control--error' : ''}`}
                                            onChange={(value) => {
                                                handleChangeState('email', value);
                                            }}
                                            value={email}
                                            placeholder={t('notification_registration.registration_modal.mail_address')}
                                        />
                                    </div>
                                    {isCheckEmail && (
                                        <p id="email-error" className="okc-error mt-2 mb-0">
                                            {t('notification_registration.registration_modal.invalid_email')}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </Modal>
            <DeleteModal
                isShow={isShowDeleteModal}
                onClose={() => handleChangeState('isShowDeleteModal', false)}
                onSubmit={handleDeleteSubmit}
            />
        </>
    );
};

export default Notification;
